import React from 'react';
import { createRoot } from 'react-dom/client';

import { injectGtm } from '@/utils/gtm';
import { initDeferredSentry } from '@/utils/initDeferredSentry';
import { isRecord } from '@/utils/typeGuards';

import App from './App';
import './config/axios';
import { initApiClient } from './config/initApiClient';
import './index.css';
import reportWebVitals from './reportWebVitals';

initApiClient();
initDeferredSentry();
injectGtm();

// Chunk loading error detection and auto-recovery
let refreshAttempted = false;

// Detect chunk loading errors and auto-refresh once
window.addEventListener('error', (e) => {
  const isChunkError =
    e.message &&
    (e.message.includes('Loading chunk') ||
      e.message.includes('Unexpected token') ||
      e.message.includes('ChunkLoadError'));

  if (isChunkError && !refreshAttempted) {
    refreshAttempted = true;
    console.warn('Chunk loading error detected, refreshing page...', e.message);
    // Clear cache and reload
    if ('caches' in window) {
      void caches.keys().then((names) => {
        names.forEach((name) => {
          void caches.delete(name);
        });
      });
    }
    window.location.reload();
  }
});

// Also catch unhandled promise rejections from chunk loading
window.addEventListener('unhandledrejection', (e) => {
  const isChunkError = isRecord(e.reason) && e.reason.name === 'ChunkLoadError';

  if (isChunkError && !refreshAttempted) {
    refreshAttempted = true;
    console.warn(
      'Chunk loading promise rejection detected, refreshing page...',
      e.reason,
    );
    // Clear cache and reload
    if ('caches' in window) {
      void caches.keys().then((names) => {
        names.forEach((name) => {
          void caches.delete(name);
        });
      });
    }
    window.location.reload();
  }
});

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
